export default "__VITE_ASSET__rW2Sdizu__"